import { Alert, flash, Modal, SubmitButton } from "@xola/ui-kit";
import { SecondaryButton } from "common";
import React from "react";
import { useMutation } from "react-query";
import { TopUp } from "types";
import { api } from "../../../api/api";
import { useSeller } from "../../../hooks/useAccount";
import { useSellerResource } from "../../../hooks/useSellerResource";
import { Currency } from "../../Common/Currency";
import { NoTranslate } from "../../Common/NoTranslate";

interface PayoutTopUpModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export const PayoutTopUpModal = ({ isOpen, onClose }: PayoutTopUpModalProps) => {
    return (
        <Modal shouldCloseOnOutsideClick size="huge" isOpen={isOpen} onClose={onClose}>
            <ModalContent onClose={onClose} />
        </Modal>
    );
};

const ModalContent = ({ onClose }: { onClose: () => void }) => {
    const seller = useSeller();
    const { data: topUp } = useSellerResource([`topUpSource`]) as { data: TopUp };

    const { mutateAsync: sendEmail, isLoading } = useMutation(async () => {
        await api.get(`/sellers/${seller.id}/topUpSource?format=email`);
        onClose();
        flash.success("Top Up instructions Emailed");
    });

    return (
        <>
            <Modal.Header>Top Up Instructions</Modal.Header>
            <Modal.Body className="flex">
                <div className="mx-2 w-1/2">
                    <div className="my-4">
                        <p className="text-base font-bold">1. Update</p>
                        Your Refund reserves to an amount greater then the funds you intend to send so that they do not
                        get paid out in the subsequent payout.
                    </div>
                    <div className="my-4">
                        <p className="text-base font-bold">2. Send Funds</p>
                        Via ACH or Wire Transfer to the following account
                        <Alert className="mt-1 w-max rounded p-1" color="primary">
                            <span className="text-base font-bold">Account Number: </span>
                            <NoTranslate>{topUp?.accountNumber}</NoTranslate>
                        </Alert>
                        <Alert className="mt-1 w-max rounded p-1" color="primary">
                            Routing <span className="text-base font-bold">Number : </span>
                            <NoTranslate>{topUp?.routingNumber}</NoTranslate>
                        </Alert>
                        <Alert className="mt-1 w-max rounded p-1" color="primary">
                            Bank <span className="text-base font-bold">Name : </span>
                            <NoTranslate>{topUp?.bankName}</NoTranslate>
                        </Alert>
                        <Alert className="mt-1 w-max rounded p-1" color="primary">
                            Swift Code : <NoTranslate>{topUp?.swiftCode}</NoTranslate>
                        </Alert>
                    </div>
                    <div className="my-4">
                        <p className="text-base font-bold">3. Wait</p>
                        For the funds to become available. Typically, ACH takes 3-5 business days and Wire transfer
                        takes 24 hours. Timing may take longer and often varies, depending on the financial institution
                    </div>
                </div>
                <Alert className="w-1/2">
                    <div className="mx-2 rounded p-6">
                        <p className="text-lg font-bold">Processing Fees</p>
                        <div className="my-4">The amount deposited into your Xola account will be less these fees</div>
                        <div className="my-4">
                            <div className="flex justify-between">
                                <span>ACH</span>
                                <Currency>{5}</Currency>
                            </div>
                            <div className="flex justify-between">
                                <span>Wire Transfer</span>
                                <Currency>{8}</Currency>
                            </div>
                            <div className="flex justify-between">
                                <span>Your Bank Fees</span>
                                <Currency>{0}</Currency>
                            </div>
                        </div>
                        <div className="my-4">Please check with your bank to understand any fees they may access</div>
                    </div>
                </Alert>
            </Modal.Body>
            <Modal.Footer className="space-x-4">
                <SecondaryButton onClick={onClose}>Cancel</SecondaryButton>
                <SubmitButton isLoading={isLoading} onClick={sendEmail}>
                    Email These Instructions
                </SubmitButton>
            </Modal.Footer>
        </>
    );
};
